import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	standalone: true,
	name: 'codeClientDesignation'
})
export class CodeClientDesignationPipe implements PipeTransform {
	transform(value: any): string {
		if (!value) {
			return '';
		}
		if (!value.codeClient) {
			return `${value.designation}`;
		}
		return `${value.codeClient.toUpperCase()} - ${value.designation}`;
	}
}
